import React, { useState } from 'react';
import FloatingLabel from '../../../components/FloatingLabel/FloatingLabel';
import { Form, Select } from 'antd';
import { ChevronDown, CheckCircle, ChevronUp } from '../../../assets/icons';
import useMediaQuery from '../../../Hooks/useMediaQuery';

const TransactionListFilter = (props) => {
  const { filterValue, action, label, filterType, defaultValue } = props;
  const [isOpen, setIsOpen] = useState(false);
  const screenSM = useMediaQuery('(min-width: 640px)');
  const filterOptions = {
    transactionType: [
      { name: 'All', value: 'All' },
      { name: 'Buy', value: 'Bought' },
      { name: 'Sell', value: 'Sold' },
      { name: 'Dividend', value: 'Dividend' },
      { name: 'Deposit', value: 'Deposit' },
      { name: 'Withdrawal', value: 'Withdrawal' },
    ],
    timePeriod: [
      { name: 'Last 7 days', value: '7' },
      { name: 'Last 30 days', value: '30' },
      { name: 'Last 60 days', value: '60' },
      { name: 'Last 90 days', value: '90' },
      { name: 'Last 12 months', value: '365' },
      // { name: 'Custom', value: 'custom' },
    ],
    shareType: [
      { name: 'All', value: 'All' },
      { name: 'Primary', value: 'Primary' },
      { name: 'Secondary', value: 'Secondary' },
    ],
  };
  return (
    <FloatingLabel label={label} inputId={filterType} inputValue={filterValue} className='filter-float' alwaysSmall>
      <>
        <div className='filter-anchor' id={`anchor-${filterType}`} />
        <Form.Item name={filterType}>
          <Select
            id={filterType}
            onChange={(value) => action(value)}
            value={filterValue}
            suffixIcon={isOpen ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
            onDropdownVisibleChange={() => setIsOpen(!isOpen)}
            className='filter-select'
            getPopupContainer={screenSM ? () => document.getElementById(`anchor-${filterType}`) : false}
            popupClassName='filter-select-dropdown'
            defaultValue={defaultValue}
          >
            {filterOptions[filterType].map((option) => (
              <Select.Option value={option.value} key={option.value}>
                {option.name} <CheckCircle className='check' color='#8A4743' />
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </>
    </FloatingLabel>
  );
};

export default TransactionListFilter;
